import DialogActions from './components/DialogActions'
import DialogContent from './components/DialogContent'
import DialogRoot from './components/DialogRoot'
import DialogTitle from './components/DialogTitle'
import Dialog from './Dialog'

export { DialogTitle, DialogContent, DialogActions, DialogRoot }

export default Dialog
